import React from 'react';
import {
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Popover,
  Typography,
  Stack,
} from '@mui/material';
import { Link } from 'react-router-dom';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { IGroupedSubTopic } from '../../../../store/SubTopicSlice';
import { getSubTopicUrl } from '..';
import { ITopic } from '../../../../store/TopicSlice';
import { ISubTopicForProgress } from '../../../../store/ProgressSlice';

interface SubTopicListModalProps {
  open: boolean;
  onClose: () => void;
  subTopics: Array<IGroupedSubTopic>;
  selectedSubTopicId: string;
  topicData: ITopic;
  anchorEl: HTMLElement | null;
  subTopicsProgress?: Array<ISubTopicForProgress>;
}

const SubTopicListModal: React.FC<SubTopicListModalProps> = ({
  open,
  onClose,
  subTopics,
  selectedSubTopicId,
  topicData,
  anchorEl,
  subTopicsProgress,
}) => {
  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      PaperProps={{
        sx: {
          width: '300px',
          maxHeight: '600px',
          mt: '25px',
          borderRadius: '20px',
          boxShadow: 'none',
          p: '15px',
        },
      }}
    >
      <List sx={{ pt: 0, maxHeight: '550px', overflowY: 'auto' }}>
        {subTopics.map((subTopic, index) => {
          const progress = subTopicsProgress?.find(
            (p) => p._id === subTopic._id
          );
          const isComplete = progress?.completion === 100;

          return (
            <ListItem key={subTopic._id} disablePadding>
              <ListItemButton
                component={Link}
                to={getSubTopicUrl(subTopic, topicData)}
                selected={subTopic._id === selectedSubTopicId}
                onClick={onClose}
                sx={{
                  py: 1.5,
                  px: 2,
                  borderRadius: '10px',
                  '&.Mui-selected': {
                    backgroundColor: '#F1F5F9',
                    '&:hover': {
                      backgroundColor: '#F1F5F9',
                    },
                  },
                }}
              >
                <ListItemText
                  primary={
                    <Stack direction="row" spacing={1} alignItems="center">
                      <CheckCircleIcon
                        sx={{
                          fontSize: 16,
                          color: isComplete ? '#22C55E' : '#E2E8F0',
                        }}
                      />
                      <Typography
                        sx={{
                          color: '#1E293B',
                          fontSize: '16px',
                          fontFamily: 'inherit',
                          fontWeight:
                            subTopic._id === selectedSubTopicId ? 600 : 500,
                        }}
                      >
                        {subTopic.name}
                      </Typography>
                    </Stack>
                  }
                />
              </ListItemButton>
            </ListItem>
          );
        })}
      </List>
    </Popover>
  );
};

export default SubTopicListModal;
